import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
    const dragHandleColor = theme.palette.action.active;

    return {
        layout: {
            ...theme.mixins.flex.grow(1),

            '& .react-grid-item': {
                '& .react-resizable-handle.react-resizable-handle-e::after, & .react-resizable-handle.react-resizable-handle-s::after':
                    {
                        borderRight: 'none',
                        borderBottom: `4px dotted ${dragHandleColor}`,
                        width: 25,
                    },

                '& .react-resizable-handle.react-resizable-handle-se::after': {
                    borderRight: `4px dotted ${dragHandleColor}`,
                    borderBottom: `4px dotted ${dragHandleColor}`,
                    width: 15,
                    height: 15,
                },

                '& .react-resizable-handle.react-resizable-handle-s': {
                    bottom: 5,
                    transform: 'none',
                },

                '& .react-resizable-handle.react-resizable-handle-se': {
                    bottom: 5,
                    right: 5,
                },

                '& .react-resizable-handle.react-resizable-handle-e': {
                    right: 5,
                    transform: 'rotate(-90deg)',
                },

                /*
                 * This is an ugly hack to workaround the lack of support for a custom drop placeholder in
                 * react-grid-layout.  This fixes the spacing around the drop placeholder so that it is
                 * consistent with the panel spacing.
                 */
                '&.react-grid-placeholder': {
                    background: 'none',

                    '& .react-resizable-handle.react-resizable-handle-se::after': {
                        border: 'none',
                    },

                    '& span': {
                        display: 'block',
                        position: 'relative',
                        top: theme.spacing(0.25),
                        left: 0,
                        width: `calc(100% - ${theme.spacing(1)}px)`,
                        height: `calc(100% - ${theme.spacing(1.25)}px)`,
                        margin: theme.spacing(0.5),
                        background: theme.palette.grey[500],
                        borderRadius: theme.shape.borderRadius,
                    },
                },
            },
        },

        layoutItemWrapper: {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.flexDirectionColumn,
            ...theme.mixins.flex.grow(1),
        },

        hiddenLayoutItem: {
            display: 'none',
        },

        dropMessage: {
            ...theme.mixins.flex.displayFlex,
            ...theme.mixins.flex.alignItemsCenter,
            ...theme.mixins.flex.justifyContentCenter,
            position: 'absolute',
            fontSize: 18,
            fontWeight: 'bold',
            color: theme.palette.text.secondary,

            '& svg': {
                marginRight: theme.spacing(0.5),
            },
        },
    };
});

export default useStyles;
